import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import isEqual from 'lodash/isEqual';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { issueAttributesType } from '../constants/proptype-validation';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import FilterSearchIcon from './FilterSearchIcon';
import { getUserCompanyName } from '../utils/userHelpers';

class MultiUserSelectionInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    const { issue, attributeName } = this.props;

    this.state = {
      value: issue[attributeName],
    };
  }

  render() {
    const { issue, users, className, attributeName, label, container, infoMessage, styleType, horizontalAlign } = this.props;
    return (
      <IssueFieldInlineEdit
        issue={issue}
        className={className}
        data-testid={this.props['data-testid']}
        attributeName={attributeName}
        label={label}
        getDisplayValue={(currentValue) => {
          return users.filter(u => currentValue && currentValue.includes(u.oxygenId)).map(u => u.name).join(', ');
        }}
        placeholder={T.translate('unspecifiedValue')}
        infoMessage={infoMessage}
        container={container}
        styleType={styleType}
        horizontalAlign={horizontalAlign}
      >
        {(currentValue, closeEditMode, updateIssue) => <SelectDropdown
          selectedOptions={users.filter(u => this.state.value && this.state.value.includes(u.oxygenId))}
          labelKey="name"
          valueKey="oxygenId"
          subtextGetter={getUserCompanyName}
          autofocus
          openOnFocus
          multi
          backspaceRemoves={false}
          options={users}
          searchable
          searchPlaceholder={T.translate('search')}
          searchIcon={<FilterSearchIcon />}
          onClose={closeEditMode}
          onChange={(options) => {
            const value = options.map(o => o.oxygenId);
            this.setState({ value });
          }}
          onBlur={() => {
            const { value } = this.state;
            if (!isEqual(value, issue[attributeName])) {
              updateIssue(this.state.value);
            }
          }}
        />}
      </IssueFieldInlineEdit>
    );
  }
}

MultiUserSelectionInlineEdit.displayName = 'MultiUserSelectionInlineEdit';


MultiUserSelectionInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  attributeName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  users: PropTypes.array.isRequired,
  infoMessage: PropTypes.string,
  container: PropTypes.object,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  horizontalAlign: PropTypes.bool,
};

export default MultiUserSelectionInlineEdit;
